// eslint-disable-next-line import/prefer-default-export
export enum LoginError {
  NONE= '',
  INVALID_LOGIN_DATA = 'invalid_login_data',
  TOO_MANY_LOGINS = 'too_many_logins',
  ACCOUNT_SUSPENDED = 'account_suspended'
}
